import React from 'react';
import { compose } from 'ramda';
import { withHandlers } from 'recompose';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/success/components/Cards.styled';
import Image from 'app/components/Image';
import QueueButton from 'app/features/series/components/QueueButton/QueueButton';
import Text from 'app/components/layout/Text.styled';
import { feedPanelSelected } from 'app/features/success/actions';

const UI = ({ id, url, image, name, onClick }) => (
  <S.SeriesCard href={url} target="_blank">
    <S.Card.TallThumbnail onClick={onClick} data-t={`series-card-${id}`}>
      <S.Card.Image as={Image} src={image} alt={name} />
    </S.Card.TallThumbnail>
    <Text as="h4" size="l" type="semibold" isFixedSize>
      {name}
    </Text>
    <S.QueueButtonWrapper>
      <QueueButton seriesId={id} />
    </S.QueueButtonWrapper>
  </S.SeriesCard>
);

UI.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  image: PropTypes.string,
};

UI.defaultProps = {
  id: '',
  url: '',
  image: '',
};

UI.displayName = 'SeriesCard';

const onClick =
  ({ feedPanelSelected, name, id, index }) =>
  () =>
    feedPanelSelected({ id, name, index });

const SeriesCard = compose(
  connect(null, { feedPanelSelected }),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default SeriesCard;
